import { render, staticRenderFns } from "./DropdownSetting.vue?vue&type=template&id=4312457b&scoped=true&"
import script from "./DropdownSetting.vue?vue&type=script&lang=js&"
export * from "./DropdownSetting.vue?vue&type=script&lang=js&"
import style0 from "./DropdownSetting.vue?vue&type=style&index=0&id=4312457b&lang=scss&scoped=true&"
import style1 from "./DropdownSetting.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4312457b",
  null
  
)

export default component.exports